import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './Auth/firebase';
import CommonLoader from './CommonLoader';

const PdfRedirect = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState('');
  const [pdfUrl, setPdfUrl] = useState('');

  useEffect(() => {
    const fetchPdf = async () => {
      try {
        const docRef = doc(db, 'billsPdf', id);
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists() && docSnap.data().pdfUrl) {
          // Redirect the page directly to the PDF URL (opens in browser's built-in PDF viewer)
          window.location.replace(docSnap.data().pdfUrl);
        } else {
          setErrorMsg('Bill document not found or invalid link.');
        }
      } catch (err) {
        console.error("Error fetching PDF:", err);
        setErrorMsg('Error fetching bill: ' + err.message);
      }
    };

    if (id) {
      fetchPdf();
    } else {
      setErrorMsg('No bill ID provided.');
    }
  }, [id]);

  if (errorMsg) {
    return (
      <div style={{ height: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <p className="mt-4 text-red-500 font-bold">{errorMsg}</p>
          <button 
            onClick={() => navigate('/', { replace: true })}
            className="mt-4 px-4 py-2 bg-amber-500 text-white rounded-lg"
          >
            Go Home
          </button>
        </div>
      </div>
    );
  }

  // While waiting for the redirect to happen, show the loader.

  return (
    <div style={{ height: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <CommonLoader />
      <p className="mt-4 text-gray-500 font-semibold">Opening your bill...</p>
    </div>
  );
};

export default PdfRedirect;
